import Button from '@cobliteam/colib-ui/Button';
import { UserRole } from '@cobliteam/common-types';
import useLocalStorage from '@cobliteam/hooks/src/useLocalStorage';
import { useTranslation } from '@cobliteam/i18n';
import Icon from '@cobliteam/ui/icons';
import { useLayoutEffect } from 'react';

export const THEME_STORAGE_KEY = 'cobler-theme';

type Theme = 'light' | 'dark';

// Tema escuro só para coblers validarem a migração para a Colib UI (PAI-189).
const ThemeButton = ({ role }: { role: UserRole }) => {
  const { t } = useTranslation('app-header');
  const [storedTheme, setStoredTheme] = useLocalStorage<Theme | undefined>(THEME_STORAGE_KEY);
  const isCobler = role === UserRole.COBLER;
  const isDark = isCobler && storedTheme === 'dark';

  // Quem não é cobler remove a classe: a preferência salva por um cobler no mesmo aparelho não vale para outros.
  useLayoutEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
    return () => document.documentElement.classList.remove('dark');
  }, [isDark]);

  if (!isCobler) return null;

  return (
    <Button
      variant='outline'
      size='icon-sm'
      data-testid='app-header-theme-button'
      aria-label={t('theme.dark')}
      aria-pressed={isDark}
      onClick={() => setStoredTheme(isDark ? 'light' : 'dark')}
    >
      <Icon name={isDark ? 'sun' : 'moon'} />
    </Button>
  );
};

export default ThemeButton;
